module.exports = __webpack_public_path__ + "img/luxuryyacht_thumb_01.01ee1903.jpg";